export function download() {
  channelCount(sessionStorage.getItem("channelId", "download"))
    .then(res => {
      if (res.code === 200) {
        // console.log(res, 'aaaaaaaaaa')
      } else {
        layer.msg(res.data.message);
      }
    })
    .catch(err => {
      console.log(err);
    });
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    channelCount(sessionStorage.getItem("channelId", "ios"))
      .then(res => {
        if (res.code === 200) {
          console.log('ios浏览')
        } else {
          layer.msg(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
      console.log('ios浏览')
    window.location.href =
      "itms-apps://itunes.apple.com/cn/app/%E7%94%9F%E5%8A%A8%E7%A7%91%E5%AD%A6/id1453647315?l=zh&ls=1&mt=8";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    if (!isWechart()) {
      channelCount(sessionStorage.getItem("channelId", "android"))
        .then(res => {
          if (res.code === 200) {
            console.log('anroid浏览')
          } else {
            layer.msg(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
      console.log('anroid浏览')
      // window.location.href = "https://sdkxoss.1105am.com/app/android/sdkx.apk";
      this.$getClientVersion().then(res => {
        window.location.href = res.data.content.downloadUrl;
      })
    } else {
      this.isShow = true;
    }
  }
}

export function channelCount(channelId, data) {
  return new Promise((resolve, reject) => {
    this.$post(`/v1/proxyChannel/${channelId}/counter?fields=${data}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function getClientVersion(channelId, osType) {
  return new Promise((resolve, reject) => {
    this.$get(`/appVersion/h5/latest`, {channelId}, 1, { osType})
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function isWechart() {
  var u = navigator.userAgent;
  if (u.indexOf("MicroMessenger") != -1) {
    return true;
  } else {
    return false;
  }
}


// 解决ios键盘回落留白问题
export function fixScroll(e) {
  setTimeout(()=>{
      
    if(document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA'){
      return
    }
    let result = 'pc';
    if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        result = 'ios'
    }else if(/(Android)/i.test(navigator.userAgent)) {  //判断Android
        result = 'android'
    }
    
    if( result = 'ios' ){
      document.activeElement.scrollIntoViewIfNeeded(true);
    }
  },100)

  // let u = navigator.userAgent;
  // let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // if (isIos) {
  //   // window.scrollTo(0, 0);.
  //   document.activeElement.scrollIntoViewIfNeeded(true);
  //   console.log('触发了。。。。。。。。')
  // }
}


// WEBPACK FOOTER //
// ./src/utils/common.js